import {
  FileText, FileImage, FileVideo, FileAudio, FileZip, FilePdf, File as FileGeneric,
} from "@phosphor-icons/react";

export function fileIcon(filename = "", ct = "", size = 18) {
  const ext = (filename.split(".").pop() || "").toLowerCase();
  const ctl = (ct || "").toLowerCase();
  const props = { size, weight: "duotone" };
  if (ctl.startsWith("image/") || ["jpg","jpeg","png","gif","webp","svg","heic"].includes(ext)) return <FileImage {...props} className="text-[#0EA5E9]"/>;
  if (ctl.startsWith("video/") || ["mp4","mov","mkv","webm","avi"].includes(ext)) return <FileVideo {...props} className="text-[#FF3366]"/>;
  if (ctl.startsWith("audio/") || ["mp3","wav","flac","ogg","m4a"].includes(ext)) return <FileAudio {...props} className="text-[#A855F7]"/>;
  if (ext === "pdf") return <FilePdf {...props} className="text-[#DC2626]"/>;
  if (["zip","rar","7z","tar","gz"].includes(ext)) return <FileZip {...props} className="text-[#F59E0B]"/>;
  if (["txt","md","doc","docx","csv","xls","xlsx","ppt","pptx","json","yml","yaml","xml","log"].includes(ext)) return <FileText {...props} className="text-[#3B82F6]"/>;
  return <FileGeneric {...props} className="text-black/55"/>;
}

export const fmtBytes = (b) => {
  if (!b && b !== 0) return "0 B";
  const u = ["B", "KB", "MB", "GB"]; let i = 0;
  while (b >= 1024 && i < u.length - 1) { b /= 1024; i++; }
  return `${b.toFixed(b < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
};

export const fmtRelDate = (d) => {
  const diff = Date.now() - new Date(d).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const dd = Math.floor(h / 24);
  if (dd < 30) return `${dd}d ago`;
  return new Date(d).toLocaleDateString();
};
